export class CustomerSearchQuery {
    ids?: string;
    name?: string;
    country?: string;
    searchInGravity: boolean = false;
}